import React, { useEffect, useState } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getalltagsdata } from '../../Tags/TagSlice/TagsSlices'
import { KTSVG } from '../../../../../../_metronic/helpers'
import Select, { components, MenuListProps } from 'react-select'
import { useMoveListToAnotherListMutation } from '../../../../../../services/cellcast'
import { toast } from 'react-toastify'



const MoveToAnotherListModal = ({ show, handleClose, selectedListId, callbackFn }: any) => {
  const dispatch = useDispatch()
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  const [moveListToAnotherList, { isLoading }] = useMoveListToAnotherListMutation()

  const [tag, setTag] = useState<any>([])
  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [selectedTag, setSelectedTag] = useState<any>([])

  useEffect(() => {
    dispatch(getalltagsdata())
  }, [])

  useEffect(() => {

    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.type === 'list'
      }
    }).filter((it: any) => it?._id !== selectedListId)
    let listData = filteredTags?.map((val: any) => ({ value: val?._id, label: val?.name }))

    setTag(listData)
  }, [tagslist, selectedListId])

  const handleChange = async (e: any) => {
    setSelectedTag(e)
  }

  const handleSubmmit = () => {
    moveListToAnotherList({
      prevTagId: selectedListId,
      targetTagId: selectedTag?.value,
    }).unwrap()
      .then(() => {
        toast.success('success move list')
      }).finally(() => {
        setSelectedTag([])
        callbackFn(true)
        handleClose()
      })


  }

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
      </components.MenuList>
    )
  }

  return (
    <>
      <Modal show={show} onHide={handleClose} dialogClassName='modal-dialog-centered mw-500px'>
        <div className='modal-header'>
          <h2>Move to another list</h2>
          <div className='btn btn-icon btn-sm' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2' />
          </div>
        </div>
        <div className='modal-body min-h-50px'>
          <label className='col-form-label fw-bold fs-6'>List name</label>
          <Select
            value={selectedTag}
            components={{ MenuList }}
            className='react-tags-selectbox'
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            menuPortalTarget={document.body}     //important
            options={tag}
            onChange={handleChange}
          />
        </div>
        <div className='modal-footer d-flex justify-content-end m-0'>
          <button
            onClick={() => {
              handleClose()
              setSelectedTag([])
            }}
            type='button'
            className='btn btn-light-primary'
          >
            Cancel
          </button>
          <button disabled={isLoading} onClick={handleSubmmit} id='submit' type='button' className='btn btn-primary'>
            {isLoading ? <Spinner animation='grow' size='sm' /> : 'Submit'}
          </button>
        </div>
      </Modal>
    </>
  )
}

export default MoveToAnotherListModal
